// extracted by mini-css-extract-plugin
export default {"hover-truck":"home-table-truck_hover-truck__7SYz1","changeTruck":"home-table-truck_changeTruck__tRNwI","blink":"home-table-truck_blink__kMkPC"};